import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const CONSTANTS = {
    DELETING_SPEED: 75,
    TYPING_SPEED: 150,
};

type TProps = {
    heading?: string;
    messages: string[];
};

const TypingIntro = ({ heading, messages }: TProps): JSX.Element => {
    const [state, setState] = useState({
        text: '',
        message: '',
        isDeleting: false,
        loopNum: 0,
        typingSpeed: CONSTANTS.TYPING_SPEED,
    });

    useEffect(() => {
        let timer = 0;
        const handleType = () => {
            setState(cs => ({
                ...cs, // cs means currentState
                text: getCurrentText(cs),
                typingSpeed: getTypingSpeed(cs),
            }));
            timer = setTimeout(handleType, state.typingSpeed);
        };
        handleType();
        return () => clearTimeout(timer);
    }, [state.isDeleting]);

    // CLEAR TIMEOUTS?
    useEffect(() => {
        let timer = 0;
        if (!state.isDeleting && state.text === state.message) {
            timer = setTimeout(
                () => {
                    setState(cs => ({
                        ...cs,
                        isDeleting: true,
                    }));
                },
                state.loopNum === 0 ? 0 : 2500,
            );
        } else if (state.isDeleting && state.text === '') {
            timer = setTimeout(() => {
                setState(cs => ({
                    ...cs, // cs means currentState
                    isDeleting: false,
                    loopNum: cs.loopNum + 1,
                    message: getMessage(cs, messages),
                }));
            }, 500);
        }

        return () => clearTimeout(timer);
    }, [state.text, state.message, state.isDeleting, messages]);

    function getCurrentText(currentState) {
        return currentState.isDeleting
            ? currentState.message.substring(0, currentState.text.length - 1)
            : currentState.message.substring(0, currentState.text.length + 1);
    }

    function getMessage(currentState, data) {
        return data[Number(currentState.loopNum) % Number(data.length)];
    }

    function getTypingSpeed(currentState) {
        return currentState.isDeleting ? CONSTANTS.TYPING_SPEED : CONSTANTS.DELETING_SPEED;
    }

    return (
        <Heading>
            {heading}&nbsp;
            <span className="type">{state.text}</span>
            <span id="cursor" />
        </Heading>
    );
};

export default TypingIntro;

const Heading = styled.h1`
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 12px;

    .type {
        color: ${({ theme }): string => theme.colors.brandPrimary};
    }

    #cursor {
        border-left: 0.1em solid ${({ theme }): string => theme.colors.brandPrimary};
        animation: blink 0.7s steps(1) infinite;
    }

    @keyframes blink {
        50% {
            border-color: transparent;
        }
    }
`;
